import { Controller } from "@hotwired/stimulus"
import confetti from "canvas-confetti"

export default class extends Controller {
  static values = { phase: String, reviewPrompt: Boolean }

  // Lets the confetti land before the App Store rating sheet covers the screen.
  static REVIEW_PROMPT_DELAY_MS = 1500

  static palettes = {
    morning: ["#fbbf24", "#fde68a", "#fb923c", "#60a5fa", "#38bdf8"],
    evening: ["#6366f1", "#818cf8", "#a78bfa", "#c4b5fd", "#fcd34d"],
    default: ["#f97316", "#fbbf24", "#6366f1", "#a78bfa", "#34d399"]
  }

  connect() {
    this.timeout = setTimeout(() => this.burst(), 200)

    if (this.reviewPromptValue) {
      this.reviewPromptTimeout = setTimeout(() => window.triggerNativeReviewPrompt?.(), this.constructor.REVIEW_PROMPT_DELAY_MS)
    }
  }

  disconnect() {
    clearTimeout(this.timeout)
    clearTimeout(this.reviewPromptTimeout)
  }

  burst() {
    const palettes = this.constructor.palettes
    confetti({
      particleCount: 120,
      spread: 75,
      startVelocity: 38,
      origin: { y: 0.7 },
      colors: palettes[this.phaseValue] || palettes.default
    })
  }
}
